import {
  GET_SIZE_CHART_ERROR,
  GET_SIZE_CHART_REQUEST,
  GET_SIZE_CHART_SUCCESS,
} from "./types.js";
import { BASEURL } from "../../constant/config.js";

const axios = require("axios");

export const getSizeChart = (token, value) => (dispatch) => {
  dispatch({ type: GET_SIZE_CHART_REQUEST });
  return axios({
    method: "POST",
    url: `${BASEURL}getAll/sizeChart`,
    headers: {
      Accept: "application/json",
      Authorization: "Bearer " + token,
    },
    data: {  "gender_category_id": value }
  })
    .then((response) => {
      return dispatch({ type: GET_SIZE_CHART_SUCCESS, payload: response.data });
    })
    .catch((error) => {
      return dispatch({
        type: GET_SIZE_CHART_ERROR,
        payload: error.response,
      });
    });
};